import { styled } from '@mui/material/styles';

export const StyledFormSectionContainer = styled('div')`
  ${({ theme }) => theme.breakpoints.down(760)} {
    & > div[data-test='targeting-criteria'] > .MuiGrid-container {
      padding: ${({ theme }) => theme.spacing(4, 1)};
    }
  }
`;
